import React from 'react'
import { useColorTheme } from '../../contexts/ColorThemeContext'
import type { ColorPaletteKey } from '../../styles/colorPalettes'
import { colorPalettes } from '../../styles/colorPalettes'
import './ColorPaletteMenuSelector.css'

const ColorPaletteMenuSelector: React.FC = () => {
  const { paletteKey, setPalette } = useColorTheme()

  return (
    <div className="color-palette-menu-selector">
      {Object.entries(colorPalettes).map(([key, palette]) => (
        <button
          key={key}
          className={`color-palette-option ${paletteKey === key ? 'active' : ''}`}
          onClick={() => setPalette(key as ColorPaletteKey)}
        >
          <div className="color-palette-preview">
            <span 
              className="color-dot" 
              style={{ backgroundColor: palette.colors.primary }}
            />
            <span 
              className="color-dot" 
              style={{ backgroundColor: palette.colors.secondary }}
            />
            <span 
              className="color-dot" 
              style={{ backgroundColor: palette.colors.accent }}
            />
          </div>
          <div className="color-palette-info">
            <div className="color-palette-name">{palette.name}</div>
            {/* <div className="color-palette-description">{palette.description}</div> */}
          </div>
        </button>
      ))}
    </div>
  )
}

export default ColorPaletteMenuSelector